import React from 'react';
import { ArrowRight, Building2, Check } from 'lucide-react';
import { STATES } from '../api';
import { Action, Field, Select } from '../ui';
import { useBusinessAuth } from './useBusinessAuth';

const CredentialsFields = ({ bind, register = false }) => <>
  <Field id="auth-email" label="Work email" type="email" autoComplete="email" required {...bind('email')} />
  <Field id="auth-password" label="Password" type="password" minLength={register ? 10 : undefined} maxLength={72}
    autoComplete={register ? 'new-password' : 'current-password'}
    placeholder={register ? 'At least 10 characters' : 'Enter your password'} required {...bind('password')} />
</>;

const RoleChoice = ({ role, setRole }) => <div className="role-choices">
  {['buyer', 'supplier'].map(value => <button type="button" key={value} data-testid={`register-role-${value}`}
    className={role === value ? 'selected' : ''} onClick={() => setRole(value)}>
    <Building2 size={19} /><span>{value === 'buyer' ? 'I want to buy' : 'I want to supply'}</span>
    {role === value && <Check size={15} />}
  </button>)}
</div>;

const BusinessIdentityFields = ({ bind }) => <>
  <Field id="register-gstin" label="GSTIN" placeholder="27ABCDE1234F1Z5" minLength={15} maxLength={15} required {...bind('tax_id')} />
  <div className="form-grid">
    <Field id="register-city" label="City" required {...bind('city')} />
    <Select id="register-state" label="Business state" {...bind('state_code')}>
      {STATES.map(([code, name]) => <option key={code} value={code}>{name}</option>)}
    </Select>
  </div>
  <p className="form-note">India · INR. Other countries will be added after their tax and commercial requirements are configured.</p>
</>;

const SubmitAccount = ({ busy, error, children }) => <>
  {error && <div className="notice error" data-testid="auth-error" role="alert">{error}</div>}
  <Action id="auth-submit" type="submit" busy={busy} className="full-width">{children}<ArrowRight size={17} /></Action>
</>;

export const LoginForm = () => {
  const model = useBusinessAuth(false);
  return <form onSubmit={model.submit}>
    <CredentialsFields bind={model.bind} />
    <SubmitAccount busy={model.busy} error={model.error}>Sign in</SubmitAccount>
  </form>;
};

export const RegisterForm = ({ initialRole }) => {
  const model = useBusinessAuth(true, initialRole);
  return <form onSubmit={model.submit}>
    <RoleChoice role={model.form.role} setRole={value => model.setField('role', value)} />
    <div className="form-grid">
      <Field id="register-name" label="Full name" required {...model.bind('name')} />
      <Field id="register-company" label="Legal business name" required {...model.bind('company')} />
    </div>
    <CredentialsFields bind={model.bind} register />
    <BusinessIdentityFields bind={model.bind} />
    <SubmitAccount busy={model.busy} error={model.error}>Submit business application</SubmitAccount>
  </form>;
};